export enum CRUDActions {
  None = 0,
  Create = 1,
  Update = 2,
  Delete = 3,
  Cancel = 4,
  Commit = 5,
}
